const InvestmentBrokersEnum = Object.assign({
  EXPORO_AG: 'Exporo AG',
  EPH_GMBH: 'EPH Investment GmbH',
});

Object.freeze(InvestmentBrokersEnum);

export default InvestmentBrokersEnum;



// WEBPACK FOOTER //
// ./src/enum/financialProducts/InvestmentBrokers.js